var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DropDown',{attrs:{"field":_vm.fieldWithOptions,"value":_vm.value},on:{"input":_vm.updateField}})}
var staticRenderFns = []

export { render, staticRenderFns }